<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.associations', 1) }}
                    </h3>
                </div>
            </div>

            <div class="card-body">
                <div class="card">
                    <div class="card-body p-1em">
                        <h3 class="card-title text-center mb-0">
                      
                        </h3>
                    </div>
                    <b-container>
                        <div class="list-group list-group-flush">
                            <b-row>

                                <b-col col sm="12">
                                    <div class="list-group-item">
                                        {{ $t('message.region') }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mAssociation.region).toUpperCase() }}
                            </span>
                                    </div>
                                </b-col>


                                <div class="col-sm-12">
                                    <div class="list-group-item">
                                        {{ $tc('message.cities',1) }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mAssociation.ville).charAt(0).toUpperCase()+""+getValue(mAssociation.ville).slice(1) }}
                            </span>
                                    </div>
                                </div>

                          

                                <div class="col-sm-12">
                                    <div class="list-group-item">
                                        {{ $tc('message.association', 1) }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mAssociation.nom).charAt(0).toUpperCase()+""+getValue(mAssociation.nom).slice(1) }}
                            </span>
                                    </div>
                                </div>
                            

                                <div class="col-sm-12">
                                    <div class="list-group-item">
                                        {{ $t('message.adresse') }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mAssociation.localisation).charAt(0).toUpperCase()+""+getValue(mAssociation.localisation).slice(1) }}
                            </span>
                                    </div>
                                </div>

                                <div class="col-sm-12">
                                    <div class="list-group-item">
                                        {{ $t('message.email') }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mAssociation.email) }}
                            </span>
                                    </div>
                                </div>

                                <div class="col-sm-12">
                                    <div class="list-group-item">
                                        {{ $t('message.phoneNumber') }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mAssociation.telephone) }}
                            </span>
                                    </div>
                                </div>

                            </b-row>

                        </div>
                    </b-container>
                    <b-container>
                        <b-row class="justify-content-sm-center" v-if="can">
                            <div class="card-footer text-right">
                                <b-button variant="primary" @click="updateAssociation">
                                    {{ $t('message.edit') }}
                                </b-button>

                                <b-button v-b-modal.delete-modal variant="danger">
                                    {{ $t('message.delete') }}
                                </b-button>
                            </div>
                        </b-row>
                    </b-container>

                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.associations', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mAssociation.nom }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteAssociation">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import AppConfig from '../../constants/AppConfig';


    export default {
        name: "Associations",

        computed: {
            ...mapGetters(["Association",'hasAdminRole',
                'hasGestionnaireRole','hasMedecinControleRole','hasAssistante']),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.hasAssistante;
            },

            mAssociation: function() {
                return this.Association;
            },

            fullName:function () {
                let nom  = this.mAssociation.nom != null ? this.mAssociation.nom : "";
                nom =   getValue(nom);
                return nom.charAt(0).toUpperCase();
            },
        },

        data() {
            return {
                association_id: this.$route.params.association,

                paginationOptions:{
                    enabled: true,
                    mode: 'records',
                    perPageDropdown: [3, 6, 10]
                },

                enabled:{enabled: true},
            }
        },

        methods: {

            getAssociation() {
                let args = {
                    association: this.association_id
                };

                this.$store.dispatch("getAssociation", { args });
            },

            formattedDate(date) {
                return moment(date).format('DD-MM-YYYY HH:mm');
            },

            updateAssociation() {
                this.$router.push({ name: 'edit-association', params: { association: this.association_id } });
            },

            deleteAssociation() {
                let self = this;
                let args = {
                    partenaire: this.association_id
                };

                let successMessage = this.$i18n.t('message.associationDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteAssociation', { args, index: self.association_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();

                });
            },
            getValue(item){
                if (typeof item != "undefined"){
                    return item;
                }else{
                    return "";
                }
            },
        },
        mounted() {
            this.getAssociation();
        }
    }
</script>

<style scoped>

</style>